export const RETRY_FETCH = 'reconciliationPromotions/RETRY_FETCH';
